import { render } from "./JobsPlaceholder.vue?vue&type=template&id=20b2a9f4&scoped=true"
import script from "./JobsPlaceholder.vue?vue&type=script&lang=js"
export * from "./JobsPlaceholder.vue?vue&type=script&lang=js"

import "./JobsPlaceholder.vue?vue&type=style&index=0&id=20b2a9f4&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b2a9f4"]])

export default __exports__